import { render } from "./VideoPlayerContainer.vue?vue&type=template&id=0d6dbaeb&scoped=true"
import script from "./VideoPlayerContainer.vue?vue&type=script&lang=js"
export * from "./VideoPlayerContainer.vue?vue&type=script&lang=js"

import "./VideoPlayerContainer.vue?vue&type=style&index=0&id=0d6dbaeb&lang=scss&scoped=true"

import exportComponent from "/Users/tpere/RocketBears/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6dbaeb"]])

export default __exports__